module.exports = __webpack_public_path__ + "static/img/7.440947a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/7.png
// module id = 06Wl
// module chunks = 1